<template>
  <v-container fluid>
    <SearchBar v-model="search" />

    <v-card outlined class="rounded-xl">
      <ListTitle
        title="Location"
        @new="$router.push({ path: 'create' })"
      />

      <!-- Loader when no data -->
      <v-card-text v-if="locations.length === 0 && loading">
        <CSPLoader model />
      </v-card-text>

      <v-data-table
        :headers="headers"
        :items="locations"
        :options.sync="options"
        :server-items-length="count"
        :loading="loading"
        class="table-header"
        :footer-props="{ 'items-per-page-options': rowsPerPageItems }"
      >
        <!-- ✅ Modern item slot (no <tr v-for>) -->
        <template v-slot:item="{ item, index }">
          <tr>
            <td>#{{ index + 1 }}</td>

            <td class="text-left" data-cy="locationComponentListCode">
              {{ item.code }}
            </td>

            <td
              class="text-left large-td"
              data-cy="locationComponentListName"
              v-html="$options.filters.highlight(item.name, search)"
            >
              {{ item.name }}
            </td>

            <td
              v-if="!$vuetify.breakpoint.xs"
              class="text-left large-td"
              data-cy="locationComponentListPhone"
              v-html="
                $options.filters.highlight(item.Address.phoneNumber, search)
              "
            >
              {{ item.Address.phoneNumber }}
            </td>

            <td
              class="text-left large-td"
              data-cy="locationComponentListAddress"
              v-html="
                $options.filters.highlight(item.Address.addressLine1, search)
              "
            >
              {{ item.Address.addressLine1 }}
            </td>

            <td
              v-if="!$vuetify.breakpoint.xs"
              class="text-left large-td"
              data-cy="locationComponentListCity"
              v-html="$options.filters.highlight(item.Address.city, search)"
            >
              {{ item.Address.city }}
            </td>

            <!-- Action Menu -->
            <td class="text-right px-0">
              <v-menu bottom left offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on">
                    <v-icon data-cy="locationComponentListMoreOption"
                      >mdi-dots-vertical</v-icon
                    >
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item @click="viewLocation(item)">
                    <v-list-item-title>{{
                      $t("buttons.view")
                    }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item :href="getRegisterURL(item)" target="_blank">
                    <v-list-item-title>Open Register</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import locationService from "../service.js";

export default {
  name: "location-list",
  data() {
    return {
      terminalURL: process.env.VUE_APP_TERMINALURL,
      clientName: process.env.VUE_APP_CLIENT_NAME,
      search: "",
      locations: [],
      count: 0,
      loading: false,
      rowsPerPageItems: [10, 25, 50, 100],
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ["name"],
        sortDesc: [false],
      },
    };
  },
  computed: {
    headers() {
      if (!this.$vuetify.breakpoint.xs) {
        return [
          { text: "" },
          {
            text: this.$t("labels.code"),
            align: "left",
            value: "code",
            width: "10%",
          },
          { text: this.$t("labels.name"), value: "name" },
          { text: this.$t("labels.phoneNumber"), value: "Address.phoneNumber" },
          { text: this.$t("labels.address"), value: "Address.addressLine1" },
          { text: this.$t("labels.city"), value: "Address.city" },
          { text: "", value: "actions", sortable: false },
        ];
      }
      return [
        {
          text: this.$t("labels.code"),
          align: "left",
          value: "code",
          width: "10%",
        },
        { text: this.$t("labels.name"), value: "name" },
        { text: this.$t("labels.address"), value: "Address.addressLine1" },
        { text: "", value: "actions", sortable: false },
      ];
    },
  },
  watch: {
    search() {
      if (this.search.length > 3 || this.search.length === 0) this.getList();
    },
    options: {
      handler() {
        this.getList();
      },
      deep: true,
    },
  },
  created() {
    this.getList();
  },
  methods: {
    getRegisterURL(item) {
      const brand = this.$store.getters["brand/currentBrand"];

      // map each brand to its terminal URL
      const map = {
        REGTERMINAL: process.env.VUE_APP_TERMINALURL,
        autorepair: process.env.VUE_APP_AUTOREPAIR_TERMINALURL,
        storesync: process.env.VUE_APP_STORESYNC_TERMINALURL,
        repairnest: process.env.VUE_APP_REPAIRNEST_TERMINALURL,
      };

      const baseURL = map[brand] || process.env.VUE_APP_TERMINALURL;

      return `${baseURL}/login/location?code=${item.code}`;
    },
    async getList() {
      this.loading = true;
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      const offset = (page - 1) * itemsPerPage;
      try {
        const response = await locationService.getAll({
          limit: itemsPerPage,
          offset,
          search: this.search,
          orderBy: [sortBy[0], sortDesc[0] ? "DESC" : "ASC"],
        });
        this.locations = response.data;
        this.count = response.count;
      } finally {
        this.loading = false;
      }
    },
    viewLocation(location) {
      this.$router.push({ path: `/location/${location.id}/profile` });
    },
  },
};
</script>

<style lang="scss" scoped>
.newLocationCard {
  text-align: center;
  background-color: #e37475;
  color: white;
  font-weight: 500;
}

.table-header td {
  vertical-align: middle;
}
</style>